import script from "./RequestTypeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequestTypeIcon.vue?vue&type=script&lang=ts&setup=true"

import "./RequestTypeIcon.vue?vue&type=style&index=0&id=79581e9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79581e9f"]])

export default __exports__